import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { StyledBreadcrumb } from 'components/styledComponents/breadcrump/Breadcrump.styled';
import { handleNavigate } from 'utils/helpers';
import { IconSvg } from 'shared/icon';
import { resetBreadCrumbParams } from 'app/settings/slices';
import { useAppDispatch } from 'store/hooks';
import { BreadcrumbConfig } from 'router/types';
import type { BreadcrumbProps } from 'antd';

type BreadcrumbItem = NonNullable<BreadcrumbProps['items']>[number];

export type BreadcrumbItemExtra = BreadcrumbItem & {
  isActive?: boolean;
};

interface BreadcrumbNavigationProps {
  breadcrumb: BreadcrumbConfig[];
}

const BreadcrumbNavigation = ({ breadcrumb }:BreadcrumbNavigationProps) => {
  const params = useParams();

  const { t } = useTranslation();

  const { colors } = useTheme();
  const dispatch = useAppDispatch();

  useEffect(() => () => {
    dispatch(resetBreadCrumbParams());
  }, [dispatch]);

  const itemRender = ({ path, title, isActive }: BreadcrumbItemExtra) => (
    <span onMouseDown={(e) => (isActive === false ? null
      : handleNavigate(e, path as string))}
    >
      {title}
    </span>
  );

  const getItems = (): BreadcrumbProps['items'] => {
    if (breadcrumb) {
      return breadcrumb.map((route) => {
        let { path } = route;
        if (Object.keys(params).length && path) {
          path = Object.keys(params).reduce((result, param) => result.replace(`:${param}`, String(params[param])), path);
        }

        return {
          ...route,
          className: !route.isActive ? 'inactive-item' : '',
          title: route.key ? route.name : t(route.name as string),
          path,
        } as BreadcrumbItem;
      });
    }

    return [];
  };

  return (
    <StyledBreadcrumb
      separator={<IconSvg icon="ArrowRightIcon" width="0.29rem" height="0.5rem" color={colors.primaryText} />}
      items={getItems()}
      itemRender={itemRender}
    />
  );
};

export default BreadcrumbNavigation;
